/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'utils/loadable';

export const SupplierPage = lazyLoad(
  () => import('./index'),
  module => module.SupplierPage
);
